import { useEffect } from "react"

function useOnClickOutside(
  ref: $TSMigrationFixMe,
  handler: $TSMigrationFixMe,
  eventType: $TSMigrationFixMe,
  exceptionId: $TSMigrationFixMe
) {
  useEffect(() => {
    const listener = (event: $TSMigrationFixMe) => {
      const exceptionElement = document.getElementById(exceptionId)

      if (
        !ref.current ||
        ref.current.contains(event.target) ||
        (exceptionElement && exceptionElement.contains(event.target))
      ) {
        return
      }

      typeof handler === "function" && handler(event)
    }

    document.addEventListener("mousedown", listener)
    document.addEventListener("touchstart", listener)
    eventType && document.addEventListener(eventType, listener)

    return () => {
      document.removeEventListener("mousedown", listener)
      document.removeEventListener("touchstart", listener)
      eventType && document.removeEventListener(eventType, listener)
    }
  }, [ref, handler, eventType, exceptionId])
}

export default useOnClickOutside
